/**
 * 공지사항 상세 보기 페이지 컴포넌트
 * URL 파라미터(no)로 받은 게시물 ID에 해당하는 공지사항 게시물의
 * 상세 내용을 표시합니다. 첨부파일 다운로드 기능을 제공합니다.
 */

import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import SubPage from '../template/SubPage';
import Item from '../components/Item.jsx';
import useAsync from '../hooks/useAsync';
import { getNotices } from '../Api';
import MyHelmet from '../hooks/Helmet';

// 한 번에 가져올 게시물 수
const LIMIT = 6;

function NoticeDetailPage() {
  const no = useParams().no;
  const [order, setOrder] = useState('createdAt');
  const [isLoading, loadingError, getNoticessAsync] = useAsync(getNotices);
  const [items, setItems] = useState([]);

  // 메뉴 항목 정의
  const menuItems = [
    { id: 'notice', label: '공지사항', path: '/notice' },
    { id: 'data', label: '언론보도', path: '/data' },
    { id: 'photo', label: '포토갤러리', path: '/photo' },
  ];

  /**
   * 공지사항 데이터를 로드하는 핸들러
   */
  const handleLoad = useCallback(
    async (options) => {
      const result = await getNoticessAsync(options);
      if (!result) return;

      const datas = result;
      if (options.offset === 0) {
        setItems(datas);
      } else {
        setItems((prevItems) => [...prevItems, ...datas]);
      }
      setOrder('createdAt');
    },
    [getNoticessAsync]
  );

  useEffect(() => {
    handleLoad({ order, offset: 0, limit: LIMIT });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <MyHelmet />
      <SubPage
        title="커뮤니티"
        description="중구행복돌봄센터는 함께하는 가치로 사람중심, 상호신뢰와 배려, 같이 삶을 실현하는 공동체입니다."
        menuItems={menuItems}
        currentNo="notice"
        submenuTitle="공지사항"
        breadcrumbMenu="커뮤니티"
        breadcrumbLink="/notice"
      >
        {!isLoading && <Item items={items} no={no} order="/notice" />}
        {loadingError?.message && (
          <ErrorMessage>{loadingError.message}</ErrorMessage>
        )}
      </SubPage>
    </>
  );
}

export default NoticeDetailPage;

/* Styled Components */

const ErrorMessage = styled.span`
  color: #e74c3c;
  font-size: 14px;
  display: block;
  margin-top: 20px;
`;
